

export default function AlarmRecord() {
    
    return (
        <div>
            敬請留意....
        </div>
    )

}